import Select from 'react-select';
// Images
import ArrowDownIcon from 'images/arrow-down.svg';

const selectStyles = {
    control: (provided) => ({
        ...provided,
        cursor: "pointer",
        backgroundColor: "#0B1723",
        color: "white",
        border: "1px solid #382F5C",
        padding: "10px 12px 10px 4px",
        outline: "none",

        ":hover": {
            border: "1px solid #666699",
            outline: "none",
        },

        ":focus": {
            border: "1px solid #666699",
            outline: "none",
        },

        ":active": {
            border: "1px solid #666699",
            outline: "none",
        },
        
    }),
    menu: (provided) => ({
        ...provided,
        color: "white",
        borderRadius: 10,
        overflow: "hidden",
        boxShadow: "0px 0px 4px 0px #7357EB40",
        backgroundColor: "#0B1723",
    }),
    option: (baseStyles) => ({
        ...baseStyles,
        backgroundColor: "#0B1723",
        ":hover": {
            backgroundColor: "#132639",
        }
    }),
    singleValue: (baseStyles) => ({
        ...baseStyles,
        color: "white",
    }),
    input: (baseStyles) => ({
        ...baseStyles,
        color: "white",
    })
};

const Dropdown = ({
    selectedOption,
    onChange,
    options
}) => {

    return (
        <Select
            options={options}
            value={selectedOption}
            onChange={(newValue) => {
                onChange(newValue);
            }}
            backspaceRemovesValue={false}
            components={{ DropdownIndicator: () => <img src={ArrowDownIcon} />, IndicatorSeparator: null }}
            isClearable={false}
            isSearchable={false}
            hideSelectedOptions={false}
            menuPosition={"absolute"}
            menuPlacement={"auto"}
            styles={selectStyles}
            tabSelectsValue={false}
        />
    );
};

export default Dropdown;
